import axios from 'axios';

const BASE_URL = '/api/rules';

export async function getRules() {
  try {
    const { data } = await axios.get(BASE_URL);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch rules');
  }
}

export async function createRule(rule) {
  try {
    const { data } = await axios.post(BASE_URL, rule);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to create rule');
  }
}

export async function updateRule(id, rule) {
  try {
    const { data } = await axios.put(`${BASE_URL}/${id}`, rule);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to update rule');
  }
}

export async function deleteRule(id) {
  try {
    const { data } = await axios.delete(`${BASE_URL}/${id}`);
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to delete rule');
  }
}

/**
 * Save a rule: create if no id, otherwise update.
 * @param {object} rule
 */
export async function saveRule(rule) {
  if (rule.id) {
    return updateRule(rule.id, rule);
  }
  return createRule(rule);
}
